import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/native/index.css'
import { startNativeLaunchUrlCapture } from '@/lib/native/captureNativeLaunchUrl'

// Before React mounts: stash BankID deep links so Android process-kill cold
// starts cannot lose nativeCode before Auth/exchange runs.
startNativeLaunchUrlCapture();

createRoot(document.getElementById("root")!).render(<App />);
